import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { CircularProgress, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import useNotification from '../../../core/hooks/use_notification';
import { GET_ROUTE_PRICE_LIST, GET_ROUTE_PRICE_LISTS_EDIT } from '../../../core/constants';
import { getPriceListsState } from '../../../features/price/get_price_lists';
import { deletePriceListNotificationData } from '../../../core/utils/notification_utils';
import { ApiRequestStatusEnum } from '../../../core/enums/common/api';
import { deletePriceListAction, deletePriceListState } from '../../../features/price/delete_price_list';

const PriceListsList = ({ queryParams, refreshList }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showNotification } = useNotification();

    const getPriceLists = useSelector(getPriceListsState);
    const deletePriceList = useSelector(deletePriceListState);

    const onRemovePriceList = (id) => {
        dispatch(deletePriceListAction(id))
            .then(response => {
                showNotification(deletePriceListNotificationData(response));
                response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED && refreshList();
            });
    };

    return (
        <TableContainer component={ Paper } variant="outlined">
            <Table stickyHeader>
                <TableHead>
                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                        <TableCell  sx={ { width: 100 } }>Numer</TableCell>
                        <TableCell>Nazwa</TableCell>
                        <TableCell align="center" sx={ { width: 180 } }>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        getPriceLists?.data?.content?.map(priceList => (
                            <TableRow key={ priceList?.id } hover>
                                <TableCell sx={ { fontWeight: 600 } }>{ priceList?.id }</TableCell>
                                <TableCell>{ priceList?.name }</TableCell>
                                <TableCell align="center">
                                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={ 1 }>
                                        <Tooltip title="Edytuj cennik">
                                            <IconButton
                                                color="primary"
                                                size="small"
                                                onClick={ () => navigate(GET_ROUTE_PRICE_LISTS_EDIT(priceList?.id)) }
                                            >
                                                <EditIcon fontSize="small"/>
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Szczegóły">
                                            <IconButton
                                                size="small"
                                                onClick={ () => navigate(GET_ROUTE_PRICE_LIST(priceList?.id), { state: { queryParams } }) }
                                            >
                                                <SearchIcon fontSize="small"/>
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Usuń cennik">
                                            <IconButton
                                                onClick={ () => onRemovePriceList(priceList?.id) }
                                                disabled={ deletePriceList?.loading }
                                            >
                                                {
                                                    deletePriceList?.loading
                                                        ? <CircularProgress size={ 20 } color="inherit"/>
                                                        : <DeleteForeverIcon/>
                                                }
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))
                    }

                    { (!getPriceLists?.data?.content || getPriceLists?.data?.content.length === 0) && (
                        <TableRow>
                            <TableCell colSpan={ 7 } align="center" sx={ { py: 4, color: 'text.secondary' } }>
                                Brak wyników do wyświetlenia.
                            </TableCell>
                        </TableRow>
                    ) }
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PriceListsList;